import SodCustomDonutChart from './CustomDonutChart';
export default SodCustomDonutChart;
